import PlayerInfo from './PlayerInfo'

export default PlayerInfo
